import { Fragment } from 'react';

import { SmartTableCellProps } from '@/components/ui/daisy';
import StudentExam from '@/models/StudentExam';

export default function ExamCell({
  item,
}: SmartTableCellProps<Pick<StudentExam, 'exam'>>) {
  return <Fragment>{item.exam.name}</Fragment>;
}
